var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-left col-sm-6 col-xs-12",attrs:{"id":"verify-container","grid-list-xs":""}},[_c('h1',[_vm._v("Welcome "+_vm._s(_vm.sourcePretty)+"!")]),_c('SignupForm',{attrs:{"onboard-source":_vm.source}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }